import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { uploadReset } from "../../redux/Actions/SingleUserActions";
import Storage from "../../utils/storage";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import { getDocs, getUserStatus, getRequiredDocs } from "../../redux/Actions/GetDocsActions";
import { useHistory } from "react-router-dom";
import Alert from "../../utils/Alert";
import POSRequirement from "./POSRequirement";
import jwt_decode from "jwt-decode";
import { uploadPosDeviceDocs } from "../../redux/Actions/PosActions";
import {getCertificationAmount} from "../../redux/Actions/GetDocsActions"
import UserStatus from "../../components/Certification/UserStatus";
import DocsUpload from "./DocsUpload";
import checkDocs from "../../utils/Functions/CheckCategory";
import assign from "../../utils/Functions/AssignObj";
import UpdateArray from "../../utils/Functions/UpdateArray";
import Spinner from "react-spinner-material";
import { number, PropTypes } from "prop-types"

export const DeviceUploadApp = (props) => {
  const {
    isGetting,
    getDocsList,
    getStatus,
    dashboardData,
    isUploading,
    uploadSuccess,
    uploadDocs,
    uploadedDoc,
    uploadReset,
    docs,
    isFetching,
    getStatusSuccess,
    requiredDocs,
    getRequiredDocs,
    isFetchingRequiredDocs,
    getRequiredDocsSuccess,
    getCertificationAmount,
    
  } = props;

  const history = useHistory();

  let userToken = Storage.get("user-access-token");
  const token = jwt_decode(userToken);
  let userCompanyId = token && token.id;
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let categoryChoice = user && user.category_id;

  const [state, setState] = useState({
    openModal: false,
    fileResult: {},
    allResult: [],
    errorMessage: "",
    items: [],
    document: [],
    inputValue: "",
  });

  useEffect(
    () => {
      uploadReset();
      const type = "application"
      getRequiredDocs(type)
      getStatus();
    },
    // eslint-disable-next-line
    [uploadReset, getRequiredDocs, getStatus]
  );

  const appStatus =
    dashboardData && dashboardData[1] && dashboardData[1].pos_application;
  const userAppStatus2 = appStatus && appStatus[0] && appStatus[0].status;
  const userAppStatus =
    appStatus && appStatus[0] && appStatus[0].nibss_super_admin_status;

  useEffect(
    () => {
      if (getStatusSuccess) {
        const type = "certification";
        getDocsList(type);
      }
    },
    // eslint-disable-next-line
    [getStatusSuccess, getDocsList]
  );

  const categoryDocs = requiredDocs && requiredDocs[categoryChoice] && requiredDocs[categoryChoice].documents

  const uploadedDocs = docs && docs[0] && docs[0].documents;
  const filteredUploadedDocs =
    uploadedDocs &&
    uploadedDocs.filter(
      (item) =>
        item.id === 1 ||
        item.id === 30 ||
        item.id === 31 ||
        item.id === 32 ||
        item.id === 33 ||
        item.id === 34
    );

  checkDocs(categoryDocs, filteredUploadedDocs);

  function handleDataFetch(fileResult) {
    if (filteredUploadedDocs && filteredUploadedDocs.length > 0) {
      let allResult = uploadedDocs;
      setState({
        allResult,
      });
      UpdateArray(allResult, fileResult);
      setState({ allResult });
    } else {
      let allResult = [...state.allResult];
      UpdateArray(allResult, fileResult);
      setState({ allResult });
    }
  }

  const handleRemoval = (fileResult) => {
    state.allResult &&
      state.allResult.splice(
        state.allResult.findIndex((item) => item.id === fileResult.id),
        1
      );
    setState(JSON.parse(JSON.stringify(state)));
    return state.allResult
  };

  // NOSONAR
  const appDetails = props.location.state;
  // NOSONAR
  const appName =
    appDetails &&
    appDetails.application &&
    appDetails.application.application_name;
    // NOSONAR
  const appVersion =
    appDetails &&
    appDetails.application &&
    appDetails.application.application_version;
    // NOSONAR
  const appCertified =
    appDetails && appDetails.application && appDetails.application.device;
    // NOSONAR
  const certifiedDeviceModel =
    appDetails && appDetails.application && appDetails.application.device_model;

// NOSONAR
    const deviceLongitude = appDetails && appDetails.application && appDetails.application.device_longitude;
    // NOSONAR
    const deviceLatitude = appDetails && appDetails.application && appDetails.application.device_latitude;
    // NOSONAR
    const posDeviceType = appDetails && appDetails.application && appDetails.application.posDevice_type;
    // NOSONAR
    const merchantClass = appDetails && appDetails.application && appDetails.application.merchant_class;
    // NOSONAR
    const applicationBvn = appDetails && appDetails.application && appDetails.application.application_bvn;
    // NOSONAR
    const applicationTin = appDetails && appDetails.application && appDetails.application.application_tin;
  let inputdocs = [];
  let obj1 = {
    id: 27,
    url: appVersion,
  };
  let obj2 = {
    id: 28,
    url: appName,
  };
  let obj3 = {
    id: 29,
    url: appCertified,
  };
  let obj4 = {
    id: 35,
    url: certifiedDeviceModel,
  };

  inputdocs.push(obj1, obj2, obj3, obj4 );

  const uploadDocs1 = () => {
    let allFiles = [];
    let data =
      state.allResult &&
      state.allResult.filter(
        (item) =>
          item.id === 30 ||
          item.id === 31 ||
          item.id === 32 ||
          item.id === 33 ||
          item.id === 34
      );
    assign(data, allFiles);

    const files = {
      company_id: userCompanyId && userCompanyId.toString(),
      type: "application",
      document: inputdocs.concat(allFiles),
      device_longitude: deviceLongitude,
      device_latitude: deviceLatitude,
      posDevice_type: posDeviceType,
      merchant_class: merchantClass,
      application_bvn: applicationBvn,
      application_tin: applicationTin,
    };
    uploadDocs(files);
  };

  const uploadDocs2 = () => {
    let allFiles = [];
    let data =
      state.allResult &&
      state.allResult.filter(
        (item) =>
          item.id === 1 ||
          item.id === 30 ||
          item.id === 31 ||
          item.id === 32 ||
          item.id === 33 ||
          item.id === 34
      );
    assign(data, allFiles);
    const files = {
      company_id: userCompanyId && userCompanyId.toString(),
      type: "application",
      document: inputdocs.concat(allFiles),
      device_longitude: deviceLongitude,
      device_latitude: deviceLatitude,
      posDevice_type: posDeviceType,
      merchant_class: merchantClass,
      application_bvn: applicationBvn,
      application_tin: applicationTin,
    };
    uploadDocs(files);
  };

  const uploadDeviceDocs = () => {
    if (filteredUploadedDocs && filteredUploadedDocs.length > 0) {
      uploadDocs1();
    } else {
      uploadDocs2();
    }
  };

  const disable =
    state.allResult &&
    state.allResult.filter(
      (item) =>
        item.id === 30 ||
        item.id === 31 ||
        item.id === 32 ||
        item.id === 33 ||
        item.id === 34
    ).length < 5;

  const disable2 =
    state.allResult &&
    state.allResult.filter(
      (item) =>
        item.id === 1 ||
        item.id === 30 ||
        item.id === 31 ||
        item.id === 32 ||
        item.id === 33 ||
        item.id === 34
    ).length < 6;

  useEffect(
   
    () => {
      
      if (uploadSuccess) {
        state.errorMessage = "";
        Alert(
          true,
          "success",
          "Success message",
          "Upload successful."
        );

        const appId = uploadedDoc && uploadedDoc.application_id;
      
        history.push({
          pathname: "/payment",
          state: {
            id: appId,
            type: "application",
            amount_id: 3
            
          },
        });

        getCertificationAmount(3, appId)
      }
    },
    // eslint-disable-next-line
    [uploadSuccess]
  );

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <main className="container-body">
        <UserStatus
          userAppStatus={userAppStatus}
          userAppStatus2={userAppStatus2}
          appStatus={appStatus}
          status={dashboardData}
        />

        <div className="upload-flex">
          <div className="upload-title">
            <h2>POS Application Certification Documents</h2>
            <p>
              The documents we ask for are based on your certification selection
            </p>
            <p>
              (Only pdf, png, jpeg and jpg formats are allowed with a max file
              size of 5MB)
            </p>
          </div>

          <POSRequirement type="application" />
        </div>

        {isGetting || isFetchingRequiredDocs ? (
          <div className="center-spinner2">
            <br />
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        ) : (
            getRequiredDocsSuccess && (
              <DocsUpload
                categoryDocs={categoryDocs}
                upload={uploadDeviceDocs}
                disabled={
                  filteredUploadedDocs && filteredUploadedDocs.length > 0
                    ? disable === true
                    : disable2 === true || isUploading
                }
                isUploading={isUploading}
                handleDataFetch={handleDataFetch}
                handleRemoval={handleRemoval}
                isFetching={isFetching}
                text={"PROCEED TO PAYMENT"}
                
              />
            )
          )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isUploading: state.pos.isUploading,
    uploadSuccess: state.pos.uploadSuccess,
    uploadedDoc: state.pos.uploadedDoc,
    docs: state.docs.docs,
    dashboardData: state.docs.status,
    isFetching: state.docs.isFetching,
    isGetting: state.docs.isGetting,
    getStatusSuccess: state.docs.getStatusSuccess,
    isFetchingRequiredDocs: state.docs.isGettingDocs,
    requiredDocs: state.docs.requiredDocs,
    getRequiredDocsSuccess: state.docs.getRequiredDocsSuccess,
    
  };
};

const mapDispatchToProps = (dispatch) => ({
  uploadDocs: (payload) => dispatch(uploadPosDeviceDocs(payload)),
  getDocsList: (type) => dispatch(getDocs(type)),
  getStatus: () => dispatch(getUserStatus()),
  uploadReset: () => dispatch(uploadReset()),
  getRequiredDocs: (type) => dispatch(getRequiredDocs(type)),
  getCertificationAmount: (type, appId)=> dispatch(getCertificationAmount(type, appId)),
});

DeviceUploadApp.propTypes = {
  certificationAmountId: PropTypes.number,
  dashboardData: PropTypes.array,
  docs: PropTypes.array,
  getDocsList: PropTypes.func,
  getRequiredDocs: PropTypes.func,
  getRequiredDocsSuccess: PropTypes.bool,
  getStatus: PropTypes.func,
  getStatusSuccess: PropTypes.bool,
  isFetching: PropTypes.bool,
  isFetchingRequiredDocs: PropTypes.bool,
  isGetting: PropTypes.bool,
  isUploading: PropTypes.bool,
  location: PropTypes.shape({
    state: PropTypes.shape({
      application: PropTypes.shape({
        application_name: PropTypes.string,
        application_version: PropTypes.string,
        device: PropTypes.string,
        device_model: PropTypes.string,
        device_longitude:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        device_latitude:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        posDevice_type: PropTypes.string,
        merchant_class:  PropTypes.string,
        application_bvn:  PropTypes.string,
        application_tin: PropTypes.string

      })
    })
  }),
  requiredDocs: PropTypes.object,
  uploadDocs: PropTypes.func,
  uploadReset: PropTypes.func,
  uploadSuccess: PropTypes.bool,
  uploadedDoc: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceUploadApp);
